import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Text from '@totallymoney/ui/components/Text'
import EditPencil from '@totallymoney/ui/icons/EditPencil'
import theme from '@totallymoney/ui/theme'

import RoundButton from '@components/RoundButton'

import useAppQueryState from '@hooks/useAppQueryState'

import { useMinimumGuaranteedCreditLimitQuery } from '@queries/useMinimumGuaranteedCreditLimitQuery'

import formatNumberToCurrency from '@utils/formatNumberToCurrency'

interface MinimumCreditLimitUpdateProps {
    onShowMinimumCreditLimitModal: () => void
}

const MinimumCreditLimitUpdate = ({
    onShowMinimumCreditLimitModal,
}: MinimumCreditLimitUpdateProps) => {
    const { appQueryState } = useAppQueryState()

    const { data } = useMinimumGuaranteedCreditLimitQuery({
        customerId: appQueryState.customerId,
    })

    return (
        <RoundButton onClick={() => onShowMinimumCreditLimitModal()}>
            <Flex mr="space15">
                <EditPencil size={20} color={theme.indigo100} />
            </Flex>
            {data?.minimumGuaranteedCreditLimit != null ? (
                <>
                    <Flex mr={[0, 'space10']}>
                        <Text
                            variant="80"
                            weight="bold"
                            data-testid="minCreditLimitUpdateAmount"
                        >
                            {formatNumberToCurrency(
                                data.minimumGuaranteedCreditLimit
                            )}
                        </Text>
                    </Flex>
                    <Box display={['none', 'block']} mr="space05">
                        <Text variant="80">Min. credit limit</Text>
                    </Box>
                </>
            ) : (
                <Box mr="space05">
                    <Text variant="80">Add minimum credit limit</Text>
                </Box>
            )}
        </RoundButton>
    )
}

export default MinimumCreditLimitUpdate
